
// Count Action Types
export const DECREACE = 'DECREACE'
export const INCREASE = 'INCREASE'
export const RESET    = 'RESET'

// Modal Action Types
export const MODAL_OPEN  = 'MODAL_OPEN'
export const MODAL_CLOSE = 'MODAL_CLOSE'

// Product Action Types
export const LOADING= 'LOADING'
export const GET_PRODUCT= 'GET_PRODUCT'